import {
    SET_AUTH_USER,
    SET_AUTH_ERROR,
    SET_AUTH_TOKEN,
    SET_AUTH_ROLE,
    SET_SESSION_START,
} from './constants';

const initialState = {
    token: '',
    user: '',
    error: '',
    role: '',
    sessionStart: '',
};

/**
 * Reducer function to manage the authentication state in the Redux store.
 *
 * It handles actions related to setting the authentication token,
 * user information, error messages, roles, and session start time.
 *
 * @param {Object} state - The current state of the authentication.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the authentication after applying the action.
 **/
export default function auth(state = initialState, action) {
    switch (action.type) {
        case SET_AUTH_TOKEN:
            return { ...state, token: action.token };
        case SET_AUTH_USER:
            return { ...state, user: action.user };
        case SET_AUTH_ERROR:
            return { ...state, error: action.error };
        case SET_AUTH_ROLE: {
            const { role } = action;
            return { ...state, role };
        }
        case SET_SESSION_START: {
            const { sessionStart } = action;
            return { ...state, sessionStart };
        }
        default:
            return state;
    }
}
